export function serverValidator(check, options) {
    return {
        asyncValidators: [
            async (value, ctx) => {
                const result = await check(value, ctx);
                if (result == null)
                    return [];
                return typeof result === "string" ? [result] : result;
            },
        ],
        asyncDebounceMs: options?.debounceMs ?? 0,
        asyncDependsOn: options?.dependsOn,
        asyncTimeoutMs: options?.timeoutMs,
        asyncWhen: options?.when,
    };
}
